import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "signUp-button",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signUp && _ctx.signUp(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createVNode(_component_Button, null, {
        default: _withCtx(() => [
          _createTextVNode("Sign Up for Solid!")
        ]),
        _: 1
      })
    ])
  ]))
}